// VARIABLES
var
largura = screen.width,
$linkBackSolucoes = $('.to-back'),
$kBoxSolucoes = $('.k-box-solucao'),
$boxAllSolucoes =$('.box-all-solucoes'),
$tarjaSolucao = $('.tarja-spot'),
$boxSolucoes = $('[box-all]'),
$boxKaitronn = $('[box-kaitronn]'),
$boxOmni = $('[box-omni]'),
$sectionKaitronn = $('[section-kaitronn]'),
$sectionOmni = $('[section-omni]'),
$buttonKaitronn = $('[box-kaitronn]'),
$buttonOmni = $('[box-omni]'),
$hoverKaitronn = $('[data-kaitronn]'),
$hoverOmni = $('[data-omni]'),
$menuHover = $('.nav-item.dropdown'),
$linksDownload = $('[data-download]');

$menuHover.hover(function() {
    $(this).attr('aria-expanded', true).find('.dropdown-menu').addClass('show');    
}, function(e) {
    console.log(e.target)
    $(this).attr('aria-expanded', false).find('.dropdown-menu').removeClass('show');    
});

// HANDLERS
$(window).resize(_.throttle(setHeight, 500));

$sectionOmni.ready(setHeight)

$hoverKaitronn.mouseenter(_.throttle(getKaitronn, 500));
$hoverOmni.mouseenter(_.throttle(getOmni, 500));

$buttonKaitronn.mouseenter(_.throttle(showKaitronn, 500));
$buttonOmni.mouseenter(_.throttle(showOmni, 500));
$boxSolucoes.mouseleave(_.throttle(showAll, 500))
$linkBackSolucoes.click(function(e) {
    e.preventDefault();
    showAll();
});

// FUNCTIONS
function setHeight() {
    let sectionHeightSection = $('[section-kaitronn]').outerHeight();
    $kBoxSolucoes.css('height', sectionHeightSection);
}

function getKaitronn() {
    $hoverOmni.removeClass('active')
    $(this).addClass('active')
    $('.menu-links').hide();
    $('.menu-links--kaitronn').fadeIn();
}
function getOmni() {
    $hoverKaitronn.removeClass('active')
    $(this).addClass('active')
    $('.menu-links').hide();
    $('.menu-links--omni').fadeIn();
}

function showKaitronn() {
    $tarjaSolucao.fadeIn().removeClass('bg-omni').addClass('bg-success').find(".text-omni").addClass('d-none').end().find('.text-kaitronn').removeClass('d-none');
    $boxAllSolucoes.hide();
    $sectionOmni.addClass('special-invisible')
    $sectionKaitronn.removeClass('special-invisible')
}
function showOmni() {
    $tarjaSolucao.fadeIn().removeClass('bg-success').addClass('bg-omni').find(".text-kaitronn").addClass('d-none').end().find('.text-omni').removeClass('d-none');
    $boxAllSolucoes.hide();
    $sectionKaitronn.addClass('special-invisible')
    $sectionOmni.removeClass('special-invisible')
}

function showAll() {
    $tarjaSolucao.hide();
    $boxAllSolucoes.fadeIn();
    $sectionKaitronn.addClass('special-invisible');
    $sectionOmni.addClass('special-invisible');
}

$(".menu-solucoes__solucao").click(function(e) {
    e.stopPropagation();
})

if(largura >= 768 && largura <= 1200) {
    $("#dropdownMenuLink").click(function(e) {
        $('[role=main] .dropdown-menu').toggleClass('show').toggleClass("d-none");
    })
}

